<template>
  <div class="w-100">
    <template v-if="type == 'block'">
      <div class="w-100 radius-6 box-shadow-light-aff border-form bg-white">
        <div class="row no-gutters">
          <div class="col-4" style="padding-inline: 0px !important;"> 
            <div class="w-100 radius-6 position-relative" style="height: 130px;">
              <img class="img-fit radius-l-6" :src="data.image_url" @click="goToDetail()">
                <div v-if="is_variant && product_cart_index != -1" class="position-absolute bg-green radius-6 py-1 px-2" style="bottom: 8px;right:8px;">
                <p class="mb-0 text-12 font-lato text-white">{{ product_cart.qty }}</p>
              </div>
            </div>
          </div>
          <div class="col-8" style="padding-inline: 0px !important;">
            <div class="px-3 pt-2 mb-3" @click="goToDetail()">
              <p class="mb-0 body-1-3"><text-highlight :queries="search_form">{{ data.name }}</text-highlight></p>
              <p class="mb-1 body-3-3-1 text-truncate"><text-highlight :queries="search_form">{{ data.description }}</text-highlight></p>
              <p class="mb-0 text-12 font-lato w-100">{{ $formatCurrency(price.price_sell_final_with_tax_service) }} <span class="mb-0 ml-1 text-12 font-lato-regular text-semi-light text-line-through" v-if="price.promotion_amount > 0">{{ $formatCurrency($getConciergeBasePrice(price)) }}</span></p>
            </div>
            <div class="w-100 px-3 text-right">
              <div class="d-flex w-100 justify-content-end align-items-center" v-if="!is_variant && product_cart.qty > 0">
                <div class="pos-order-qty-sm border-form bg-grey-dark mr-4" @click="toggleNote()">
                  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_598_18)">
                      <path
                        d="M2.01525 13.9142H10.7822C12.1236 13.9142 12.7911 13.2467 12.7911 11.9246V4.08825C12.7911 2.76615 12.1236 2.09868 10.7822 2.09868H2.01525C0.673889 2.09868 0 2.75973 0 4.08825V11.9246C0 13.2531 0.673889 13.9142 2.01525 13.9142ZM1.91898 12.8809C1.34778 12.8809 1.0333 12.5793 1.0333 11.9824V5.9302C1.0333 5.33976 1.34778 5.0317 1.91898 5.0317H10.8656C11.4368 5.0317 11.7578 5.33976 11.7578 5.9302V11.9824C11.7578 12.5793 11.4368 12.8809 10.8656 12.8809H1.91898Z"
                        fill="black" fill-opacity="0.85" />
                      <path
                        d="M3.03571 11.2828H7.31652C7.54111 11.2828 7.7144 11.116 7.7144 10.8977C7.7144 10.6731 7.54111 10.4934 7.31652 10.4934H3.03571C2.79825 10.4934 2.63138 10.6731 2.63138 10.8977C2.63138 11.116 2.79825 11.2828 3.03571 11.2828Z"
                        fill="black" fill-opacity="0.85" />
                      <path
                        d="M3.03571 9.35099H9.77461C9.99921 9.35099 10.1725 9.18412 10.1725 8.96593C10.1725 8.73487 9.99921 8.56158 9.77461 8.56158H3.03571C2.79825 8.56158 2.63138 8.73487 2.63138 8.96593C2.63138 9.18412 2.79825 9.35099 3.03571 9.35099Z"
                        fill="black" fill-opacity="0.85" />
                      <path
                        d="M3.03571 7.4192H9.77461C9.99921 7.4192 10.1725 7.23951 10.1725 7.01486C10.1725 6.79667 9.99921 6.62979 9.77461 6.62979H3.03571C2.79825 6.62979 2.63138 6.79667 2.63138 7.01486C2.63138 7.23951 2.79825 7.4192 3.03571 7.4192Z"
                        fill="black" fill-opacity="0.85" />
                      <path
                        d="M12.284 16C14.5367 16 16.4172 14.1195 16.4172 11.8604C16.4172 9.58846 14.556 7.72086 12.284 7.72086C10.012 7.72086 8.14442 9.59486 8.14442 11.8604C8.14442 14.1388 10.0056 16 12.284 16Z"
                        fill="white" />
                      <path
                        d="M12.284 15.1208C14.0489 15.1208 15.5443 13.6446 15.5443 11.8604C15.5443 10.0698 14.0682 8.60008 12.284 8.60008C10.4934 8.60008 9.0237 10.0762 9.0237 11.8604C9.0237 13.6575 10.4934 15.1208 12.284 15.1208Z"
                        fill="black" fill-opacity="0.85" />
                      <path
                        d="M12.284 13.9013C12.0466 13.9013 11.8925 13.7473 11.8925 13.5099V12.2519H10.6346C10.4036 12.2519 10.2431 12.0979 10.2431 11.8604C10.2431 11.623 10.4036 11.4689 10.6346 11.4689H11.8925V10.211C11.8925 9.97999 12.0466 9.81952 12.284 9.81952C12.5215 9.81952 12.6755 9.97999 12.6755 10.211V11.4689H13.927C14.1645 11.4689 14.3249 11.623 14.3249 11.8604C14.3249 12.0979 14.1645 12.2519 13.927 12.2519H12.6755V13.5099C12.6755 13.7473 12.5215 13.9013 12.284 13.9013Z"
                        fill="white" />
                    </g>
                    <defs>
                      <clipPath id="clip0_598_18">
                        <rect width="16.4172" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div class="d-flex align-items-center">
                  <div class="pos-order-qty-sm bg-green" @click="changeQty('minus')">
                    <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 1.71429H0V0H12V1.71429Z" fill="white"/>
                    </svg>
                  </div>
                  <p class="mb-0 font-lato text-14 mx-1 text-center" style="width:35px">{{ product_cart.qty  }}</p>
                  <div class="pos-order-qty-sm bg-green ml-auto" @click="changeQty('plus')">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 6.85714H6.85714V12H5.14286V6.85714H0V5.14286H5.14286V0H6.85714V5.14286H12V6.85714Z" fill="white"/>
                    </svg>
                  </div>
                </div>
              </div>
              <template v-else>
                <state-button v-if="page_module == 'outlet'" :variant="product_cart_index == -1 ? 'primary-outline' : 'primary'" size="sm" :click="addQty">{{ product_cart_index == -1 ? 'Add to cart' : 'Add more' }}</state-button>
                <state-button v-else variant="secondary" size="sm" :click="addQty">{{ product_cart_index == -1 ? 'Add to cart' : 'Add more' }}</state-button>
              </template>
            </div>
          </div>
          <!-- <div class="col-12 mt-4" v-if="index+1 < products_length">
            <div class="w-100 border-b-semi-grey"></div>
          </div> -->
        </div>
      </div>
    </template>
    <template v-else-if="type == 'square'">
      <div class="w-100 h-100 position-relative" style="padding-bottom: 40px;">
        <div class="w-100 radius-6 mb-2 position-relative" style="height: 150px;">
          <img @click="goToDetail()" class="img-fit radius-6" :src="data.image_url">
          <!-- <div v-if="is_variant" class="position-absolute bg-white border-form radius-6 py-1 px-2" style="bottom: 8px;left:8px;">
            <p class="mb-0 body-3-3-2 text-orange">{{ `${data.variant_list.length} ${$pluralWord(data.variant_list.length,'Variant')}` }}</p>
          </div> -->
          <div v-if="is_variant && product_cart_index != -1" class="position-absolute bg-green radius-6 py-1 px-2" style="bottom: 8px;right:8px;">
            <p class="mb-0 text-12 font-lato text-white">{{ product_cart.qty }}</p>
          </div>
        </div>
        <div class="w-100" @click="goToDetail()">
          <p class="mb-0 body-1-3">{{ data.name }}</p>
          <p class="mb-0 body-2-4">{{ $formatCurrency(price.price_sell_final_with_tax_service) }} <span class="mb-0 ml-1 text-12 font-lato-regular text-semi-light text-line-through" v-if="price.promotion_amount > 0">{{ $formatCurrency(price.price_sell_base) }}</span></p>
        </div>
        <div class="position-absolute w-100" style="bottom: 0px;">
          <div class="row" v-if="!is_variant && product_cart.qty > 0">
            <div class="col-4">
              <div class="pos-order-qty border-form bg-grey-dark" @click="toggleNote()">
                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_598_18)">
                    <path
                      d="M2.01525 13.9142H10.7822C12.1236 13.9142 12.7911 13.2467 12.7911 11.9246V4.08825C12.7911 2.76615 12.1236 2.09868 10.7822 2.09868H2.01525C0.673889 2.09868 0 2.75973 0 4.08825V11.9246C0 13.2531 0.673889 13.9142 2.01525 13.9142ZM1.91898 12.8809C1.34778 12.8809 1.0333 12.5793 1.0333 11.9824V5.9302C1.0333 5.33976 1.34778 5.0317 1.91898 5.0317H10.8656C11.4368 5.0317 11.7578 5.33976 11.7578 5.9302V11.9824C11.7578 12.5793 11.4368 12.8809 10.8656 12.8809H1.91898Z"
                      fill="black" fill-opacity="0.85" />
                    <path
                      d="M3.03571 11.2828H7.31652C7.54111 11.2828 7.7144 11.116 7.7144 10.8977C7.7144 10.6731 7.54111 10.4934 7.31652 10.4934H3.03571C2.79825 10.4934 2.63138 10.6731 2.63138 10.8977C2.63138 11.116 2.79825 11.2828 3.03571 11.2828Z"
                      fill="black" fill-opacity="0.85" />
                    <path
                      d="M3.03571 9.35099H9.77461C9.99921 9.35099 10.1725 9.18412 10.1725 8.96593C10.1725 8.73487 9.99921 8.56158 9.77461 8.56158H3.03571C2.79825 8.56158 2.63138 8.73487 2.63138 8.96593C2.63138 9.18412 2.79825 9.35099 3.03571 9.35099Z"
                      fill="black" fill-opacity="0.85" />
                    <path
                      d="M3.03571 7.4192H9.77461C9.99921 7.4192 10.1725 7.23951 10.1725 7.01486C10.1725 6.79667 9.99921 6.62979 9.77461 6.62979H3.03571C2.79825 6.62979 2.63138 6.79667 2.63138 7.01486C2.63138 7.23951 2.79825 7.4192 3.03571 7.4192Z"
                      fill="black" fill-opacity="0.85" />
                    <path
                      d="M12.284 16C14.5367 16 16.4172 14.1195 16.4172 11.8604C16.4172 9.58846 14.556 7.72086 12.284 7.72086C10.012 7.72086 8.14442 9.59486 8.14442 11.8604C8.14442 14.1388 10.0056 16 12.284 16Z"
                      fill="white" />
                    <path
                      d="M12.284 15.1208C14.0489 15.1208 15.5443 13.6446 15.5443 11.8604C15.5443 10.0698 14.0682 8.60008 12.284 8.60008C10.4934 8.60008 9.0237 10.0762 9.0237 11.8604C9.0237 13.6575 10.4934 15.1208 12.284 15.1208Z"
                      fill="black" fill-opacity="0.85" />
                    <path
                      d="M12.284 13.9013C12.0466 13.9013 11.8925 13.7473 11.8925 13.5099V12.2519H10.6346C10.4036 12.2519 10.2431 12.0979 10.2431 11.8604C10.2431 11.623 10.4036 11.4689 10.6346 11.4689H11.8925V10.211C11.8925 9.97999 12.0466 9.81952 12.284 9.81952C12.5215 9.81952 12.6755 9.97999 12.6755 10.211V11.4689H13.927C14.1645 11.4689 14.3249 11.623 14.3249 11.8604C14.3249 12.0979 14.1645 12.2519 13.927 12.2519H12.6755V13.5099C12.6755 13.7473 12.5215 13.9013 12.284 13.9013Z"
                      fill="white" />
                  </g>
                  <defs>
                    <clipPath id="clip0_598_18">
                      <rect width="16.4172" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </div>
            <div class="col-8">
              <div class="row no-gutters">
                <div class="col-4 align-self-center">
                  <div class="pos-order-qty bg-green" @click="changeQty('minus')">
                    <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 1.71429H0V0H12V1.71429Z" fill="white" />
                    </svg>
                  </div>
                </div>
                <div class="col-4 align-self-center text-center">
                  <p class="mb-0 font-lato text-14">{{ product_cart.qty  }}</p>
                </div>
                <div class="col-4 align-self-center">
                  <div class="pos-order-qty bg-green ml-auto" @click="changeQty('plus')">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 6.85714H6.85714V12H5.14286V6.85714H0V5.14286H5.14286V0H6.85714V5.14286H12V6.85714Z" fill="white" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <state-button v-else :variant="product_cart_index == -1 ? 'primary-outline' : 'primary'" size="sm" :click="addQty" block>{{ product_cart_index == -1 ? 'Add to cart' : 'Add more' }}</state-button>
        </div>
      </div>
    </template>

    <!-- POPUP NOTES -->
    <popup-detail 
      id_ref="add_note"
      direction="bottom" 
      :show="show_add_notes"
      use_max_size
      wrapper_size="mobile"
      use_footer
      no_close_backdrop
      @close="toggleNote()">
      <template v-slot:body>
        <div class="w-100 border-bottom p-3 position-relative mb-4">
    			<div class="d-inline-block align-middle mr-2" style="width: 45px;height:42px;">
						<img :alt="data.name" :src="data.image_url" class="img-fit radius-6">
					</div>
					<div class="d-inline-block align-middle w-75">
						<p class="mb-0 body-1-2">{{data.name}}</p>
						<p class="mb-0 body-2" v-if="data.category != null">{{data.category.name}}</p>
					</div>
					<div class="bg-white rounded-circle position-absolute border-semi-grey" style="display:inline-flex;padding:10px; right:17px;top:21px;" @click="toggleNote()">
						<img alt="close-icon" src="../../../../assets/img/icon/close.png" width="14" />
					</div>
    		</div>
        <div class="w-100 px-3 mb-4" v-if="show_add_notes">
          <textarea ref="variant_note_form" class="form-control body-2-2 mb-0" rows="4" v-model="notes"
            placeholder="Add your special request" @keyup.enter="saveNoteFromEnter"></textarea>
        </div>
      </template>
      <template v-slot:footer>
        <div class="px-3 pt-3 border-t-form">
          <state-button ref="save_note_btn" variant="primary" size="lg" :click="saveNotes" block>Save</state-button>
        </div>
      </template>
    </popup-detail>

    <!-- POPUP DETAIL -->
    <b-modal 
      v-model="show_detail"  
      centered size="md" hide-header hide-footer body-class="p-0">
      <div class="w-100" v-if="show_detail">
        <ProductDetail :page_module="page_module" :detail_data="detail_data" @close="toggleDetail()" />
      </div>
    </b-modal>
  </div>
</template>

<script>
  import TextHighlight from 'vue-text-highlight';
  import { mapGetters, mapMutations } from 'vuex';
  import ProductDetail from '@/pages/hotel/concierge/pos/ProductDetail';
  
  export default {
    props:{
      type:{
        type: String,
        default: 'block'
      },
      data:{
        type: Object,
        default: () => {}
      },
      pos:{
        type: Object,
        default: () => {}
      },
      index:{
        type: Number,
        default: 0      
      },
      products_length:{
        type: Number,
        default: 0
      },
      page_module:{
        type: String,
        default: 'outlet'
      },
      search_form:{
        type: Array,
        default: () => []
      }
    },
    components:{
      TextHighlight,
      ProductDetail
    },
    data() {
      return {
        qty: 0,
        notes: '',
        show_add_notes: false,
        show_detail: false,
        detail_data:{}
      }
    },
    computed:{
      ...mapGetters(['getMerchant', 'getOutletTrxProducts', 'getActiveHotelModule']),
      pos_code() {
        return this.$route.params.pos_code
      },
      is_variant() {
        return this.data.variant_list.length > 0 ? true : false
      },
      price(){
        let price = {}
        if(this.is_variant){
          let cloned_data = this.$deepCopy(this.data)
          let variants = cloned_data.variant_list.sort((a,b)=>a.price.price_sell_final_with_tax_service-b.price.price_sell_final_with_tax_service)
          price = variants[0].price
        }else{
          price = this.data.price
        }
        return price
      },
      product_cart_index(){
        let index = this.getOutletTrxProducts.findIndex(x=>x.product_data.id == this.data.id)
        return index
      },
      product_cart(){
        let return_data = {
          qty: 0,
          notes: ''
        }

        if(this.product_cart_index != -1){
          let cart = this.$deepCopy(this.getOutletTrxProducts[this.product_cart_index])
          if(!this.is_variant){
            return_data = {
              qty: cart.qty,
              notes: cart.notes 
            }
          }else{
            cart.variants.forEach(item=>{
              return_data.qty += item.qty
            })
          }
          
        }

        return return_data
      }
    },
    methods:{
      ...mapMutations(['setTrxOutletProduct','removeTrxOutletProduct']),
      saveToCart(qty=1,notes=''){
        let params = {
          product: this.data,
          variant: [],
          ref: 'product',
          qty: qty,
          notes: notes,
          page_module: this.page_module
        }

        params.product.product_merchant_pos = this.$selectActiveMerchantPos(params.product.product_merchant_pos, this.page_module);
        
        if(qty > 0) this.setTrxOutletProduct(params) 
        else this.removeTrxOutletProduct(params)
      },
      changeQty(type){
        let qty_cart = this.product_cart.qty
        let qty = type == 'minus' ? qty_cart-1 : qty_cart+1
        this.saveToCart(qty,this.product_cart.notes)
      },
      addQty(){
        return new Promise((success,fail)=>{
          setTimeout(()=>{
            if(this.is_variant){
              this.goToDetail()
            }else{
              this.saveToCart()
            }
            success()
          },300)
        })
      },
      toggleNote(){
        this.show_add_notes = !this.show_add_notes
        this.notes = this.product_cart.notes
        if(this.show_add_notes){
          setTimeout(() => {
            this.$refs.variant_note_form.focus()
          }, 100);
        }
      },
      saveNotes(){
        return new Promise((success,fail)=>{
          setTimeout(()=>{
            this.saveToCart(this.product_cart.qty,this.notes)
            this.toggleNote()
            success()
          },300)
        })
      },
      saveNoteFromEnter(){
        this.$refs.save_note_btn.handleClick()
      },
      goToDetail() {
        if(this.page_module == 'outlet'){
          let route = {
            name: 'PosProductDetail',
            params: {
              merchant_code: this.getMerchant.code,
              pos_code: this.pos_code,
              product_id: this.data.id
            },
            query: {
              pos_id: this.data.product_pos[0].id
            }
          }
          this.$router.push(route)
        }else{
          this.toggleDetail()
        }
      },
      toggleDetail(){
        this.show_detail = !this.show_detail
        if(this.show_detail){
          this.detail_data = {
            pos_id: this.pos.id,
            product_id: this.data.id
          }
        }else{
          this.detail_data = {
            pos_id: '',
            product_id: ''
          }
        }
      }
    }
  }
</script>
<style>
  .pos-order-qty {
    cursor: pointer;
    width: 30px;
    height: 30px;
    display: grid;
    place-items: center;
    text-align: center;
    border-radius: 6px;
  }
  .pos-order-qty-sm {
    cursor: pointer;
    width: 28px;
    height: 28px;
    display: grid;
    place-items: center;
    text-align: center;
    border-radius: 6px;
  }
</style>


// WEBPACK FOOTER //
// src/components/hotel/concierge/pos/Product.vue